import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useTenantTranslation } from "hooks/formatters";
import { useLocalDatetime } from "hooks/useLocalDateTime";

export const RecipeComplianceEmptyState = ({
  title,
  period,
  windowStart,
}: {
  title: string;
  period: "daily" | "monthly";
  windowStart: string;
}) => {
  const { t } = useTenantTranslation();
  const { localTimezone } = useLocalDatetime();
  const reportPeriod = dayjs(windowStart)
    .tz(localTimezone)
    .format(period === "monthly" ? "MMMM YYYY" : "MMM D, YYYY");
  return (
    <Stack spacing={1} sx={{ p: 3 }}>
      <Typography variant="h6">{title}</Typography>
      <Typography color="text.secondary">
        {t("noVerifiedHeatsForWindow", { period: reportPeriod })}
      </Typography>
    </Stack>
  );
};
